import { render } from "./UseinfoCollapseMenu.vue?vue&type=template&id=931e031c&scoped=true&ts=true"
import script from "./UseinfoCollapseMenu.vue?vue&type=script&lang=ts"
export * from "./UseinfoCollapseMenu.vue?vue&type=script&lang=ts"

import "./UseinfoCollapseMenu.vue?vue&type=style&index=0&id=931e031c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-931e031c"]])

export default __exports__